import { cn } from '@/legacy-src/lib/utils'

import { Text } from '@/src/domains/design-system/components/Text'
import {
  HeaderNavigationButton,
  type HeaderNavigationButtonProps,
} from '@/src/domains/header/components/Header/HeaderNavigationButton'

export type HeaderDesktopNavigationButtonProps = HeaderNavigationButtonProps

export const HeaderDesktopNavigationButton = ({
  children,
  className,
  ...props
}: HeaderDesktopNavigationButtonProps) => (
  <Text asChild weight="semibold">
    <HeaderNavigationButton {...props} className={cn('m-0 rounded-sm p-2')}>
      {children}
    </HeaderNavigationButton>
  </Text>
)
